<script>
    export default {
        name: "BaseConsentCheckbox",
        model: {
            prop: "checked",
            event: "change",
        },
        props: {
            checked: Boolean,
            error: Boolean,
        },
        methods: {
            onChange(e) {
                this.$emit("change", e.target.checked);
            },
        },
    };
</script>

<template>
    <div class="base-consent-checkbox" :class="{ 'base-consent-checkbox--error': error }">
        <label class="base-consent-checkbox__label">
            <input
                type="checkbox"
                class="base-consent-checkbox__input"
                :checked="checked"
                @change="onChange"
            />
            <span class="base-consent-checkbox__box">
                <svg
                    class="base-consent-checkbox__check"
                    width="10"
                    height="8"
                    viewBox="0 0 10 8"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M1 4L3.5 6.5L9 1"
                        stroke="currentColor"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                </svg>
            </span>
            <span class="base-consent-checkbox__text">
                Я согласен(а) на обработку персональных данных в соответствии с
                <a href="/document-confidentiality" target="_blank">Политикой конфиденциальности</a>
                и даю
                <a href="/document-personal" target="_blank">Согласие на обработку персональных данных</a>
            </span>
        </label>
        <span v-if="error" class="base-consent-checkbox__error">
            Необходимо принять согласие на обработку персональных данных
        </span>
    </div>
</template>

<style lang="scss">
    .base-consent-checkbox {
        margin-top: 12px;
    }

    .base-consent-checkbox__label {
        display: flex;
        align-items: flex-start;
        cursor: pointer;
    }

    .base-consent-checkbox__input {
        position: absolute;
        width: 1px;
        height: 1px;
        overflow: hidden;
        opacity: 0;

        &:focus-visible + .base-consent-checkbox__box {
            outline: 2px solid var(--info-text--dark, #2962ff);
            outline-offset: 2px;
        }

        &:checked + .base-consent-checkbox__box {
            background-color: var(--modal-control-fill, #2962ff);
            border-color: var(--modal-control-fill, #2962ff);

            .base-consent-checkbox__check {
                opacity: 1;
            }
        }
    }

    .base-consent-checkbox__box {
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 18px;
        height: 18px;
        margin-right: 8px;
        margin-top: 1px;
        background-color: #fff;
        border: 1px solid #b0b0b0;
        border-radius: 3px;
        transition: background-color 0.15s ease, border-color 0.15s ease;
    }

    .base-consent-checkbox__check {
        opacity: 0;
        color: #fff;
        transition: opacity 0.15s ease;
    }

    .base-consent-checkbox--error .base-consent-checkbox__box {
        border-color: #e53935;
    }

    .base-consent-checkbox__text {
        font-size: 13px;
        line-height: 18px;
        color: var(--base-text-color, #333);

        a {
            color: var(--info-text--dark, #2962ff);
            text-decoration: none;
            border-bottom: 1px solid transparent;
            transition: border-bottom-color 0.2s ease;

            &:hover {
                border-bottom-color: var(--info-text--dark, #2962ff);
            }
        }
    }

    .base-consent-checkbox__error {
        display: block;
        margin-top: 4px;
        margin-left: 26px;
        font-size: 12px;
        line-height: 16px;
        color: #e53935;
    }
</style>